import React from "react";
import { motion } from "framer-motion";

export default function StepFrame({ children, className = "", wide = false }) {
  return (
    <section className="relative min-h-[calc(100vh-4rem)] flex items-center justify-center px-6 py-20 md:py-24">
      <div className="radial-glow" />
      <motion.div
        initial={{ opacity: 0, y: 28, scale: 0.99 }}
        animate={{ opacity: 1, y: 0, scale: 1 }}
        exit={{ opacity: 0, y: -18 }}
        transition={{ duration: 0.55, ease: [0.22, 1, 0.36, 1] }}
        className={`w-full ${wide ? "max-w-6xl" : "max-w-4xl"} mx-auto ${className}`}
      >
        {children}
      </motion.div>
    </section>
  );
}

export function StepTitle({ overline, title, subtitle }) {
  return (
    <div className="text-center mb-10 md:mb-14">
      {overline && <span className="text-[11px] uppercase tracking-[0.3em] font-semibold text-hoh-rose">{overline}</span>}
      <h2 className="mt-3 text-4xl md:text-6xl font-semibold tracking-tight text-black leading-[1.05]">{title}</h2>
      {subtitle && <p className="mt-4 text-base md:text-lg text-hoh-slate max-w-xl mx-auto">{subtitle}</p>}
    </div>
  );
}
